// extracted by mini-css-extract-plugin
export default {"image":"recentProjects_image__xasqA","slide":"recentProjects_slide__tOT5c","loader":"recentProjects_loader__7G6jD"};